<template>
  <section class="mothly-view-calc bg-none table-monthly-view">
    <div v-for="n in 12" :key="n">
      <month-vue
        :current-month="n"
        :selected-month="getSelectedMonth"
        :current-year="getSelectedYear"
      />
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import MonthVue from "./Month.vue";

export default {
  components: {
    MonthVue
  },
  computed: {
    ...mapGetters({
      getSelectedYear: "getSelectedYear",
      getSelectedMonth: "getSelectedMonth"
    })
  }
};
</script>

<style scoped>
section {
  margin-top: 111px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 25px !important;
  z-index: 9 !important;
}
</style>
